var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, slides) {
buf.push("<div id=\"indicator\"><div id=\"inner\"" + (jade.attr("style", (
    "left: " + (100 / slides.length) + "%;" +
    (config.direction == "rtl" ? "margin-left: -" + (100 / slides.length) + "%;" : "")
  ), true, false)) + "></div></div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"slides" in locals_for_with?locals_for_with.slides:typeof slides!=="undefined"?slides:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}